import { HOUR_IN_MS, MIN_IN_MS } from "@/constants/date-ago";
import { MAX_TIMEOUT_DELAY } from "@/utils/useTimeout";

interface Params {
  kickoffTime: Date;
  currentTime: Date;
}

export const getPreMatchDelay = (params: Params): number => {
  const { kickoffTime, currentTime } = params;

  const timeLeftBeforeKickoff = kickoffTime.getTime() - currentTime.getTime();

  if (timeLeftBeforeKickoff > 1 * HOUR_IN_MS) {
    if (timeLeftBeforeKickoff > MAX_TIMEOUT_DELAY) {
      return MAX_TIMEOUT_DELAY;
    }
    return timeLeftBeforeKickoff - HOUR_IN_MS;
  }

  return 1 * MIN_IN_MS;
};
